"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("../../../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var BeeIcon = function BeeIcon(_ref) {
  var color = _ref.color,
    width = _ref.width,
    height = _ref.height;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 8 11",
    fill: color,
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M1.9706 8.38083C1.8221 7.71399 1.1521 7.16867 0.877102 6.80932C0.406197 6.19292 0.111076 5.4497 0.0257342 4.66525C-0.0596076 3.88081 0.0683021 3.08706 0.394729 2.37545C0.721155 1.66384 1.23282 1.06332 1.87078 0.64305C2.50874 0.222783 3.24704 -0.000126371 4.00064 5.37472e-08C4.75424 0.000126478 5.49247 0.223283 6.13031 0.643764C6.76814 1.06425 7.27962 1.66494 7.60583 2.37666C7.93203 3.08838 8.0597 3.88217 7.97412 4.66659C7.88854 5.451 7.59319 6.19413 7.1221 6.81037C6.8471 7.1692 6.1781 7.71451 6.0296 8.38083H1.9701H1.9706ZM6.0001 9.4285V9.95233C6.0001 10.2302 5.89474 10.4967 5.70721 10.6931C5.51967 10.8896 5.26532 11 5.0001 11H3.0001C2.73488 11 2.48053 10.8896 2.29299 10.6931C2.10546 10.4967 2.0001 10.2302 2.0001 9.95233V9.4285H6.0001ZM4.5001 4.19277V2.09481L2.2501 5.24044H3.5001V7.33578L5.7501 4.19277H4.5001Z"
  }));
};
BeeIcon.propTypes = _utils.iconProps;
BeeIcon.defaultProps = {
  color: '#fff',
  width: '14',
  height: '14'
};
var _default = BeeIcon;
exports.default = _default;